// ─── KFA Dropdown Option Lists ────────────────────────────────────────────────
// Single source of truth for all static dropdown options used in KFA Management.
// Keep this file in sync with the API spec.

export const LOCATION_TYPE_OPTIONS = [
  { id: 'Production', displayText: 'Production' },
  { id: 'Manufacturing', displayText: 'Manufacturing' },
  { id: 'Distribution', displayText: 'Distribution' },
];

export const ORGANIZATION_TYPE_OPTIONS = [
  { id: 'PBNA', displayText: 'PBNA' },
  { id: 'FLNA', displayText: 'FLNA' },
  { id: '1NA', displayText: '1NA' },
];

export const THREE_PL_OPTIONS = [
  { id: 'Yes', displayText: 'Yes (3PL)' },
  { id: 'No', displayText: 'No (Non-3PL)' },
];

export const SPARC_CATEGORY_OPTIONS = [
  { id: 'Safety', displayText: 'Safety' },
  { id: 'People', displayText: 'People' },
  { id: 'Accuracy', displayText: 'Accuracy' },
  { id: 'Reliability', displayText: 'Reliability' },
  { id: 'Costs', displayText: 'Costs' },
];

export const FREQUENCY_OPTIONS = [
  { id: 'Weekly', displayText: 'Weekly' },
  { id: 'Quarterly', displayText: 'Quarterly' },
];

// SPARC Walk — Section dropdown
// Maps to the `section` field in the POST/PUT payload.
export const SPARC_SECTION_OPTIONS = [
  { id: 'Behaviours', displayText: 'Behaviours' },
  { id: 'Questions', displayText: 'Questions' },
];

// ─── Observation-specific dropdown options ────────────────────────────────────

// Observation Type — hardcoded per API spec.
// Multi-select; selected values map to `observationTypeNames` (string[]) in the POST payload.
export const OBSERVATION_TYPE_OPTIONS = [
  { id: 'Pulse Check', displayText: 'Pulse Check' },
  { id: 'Routine', displayText: 'Routine' },
  { id: 'Full', displayText: 'Full' },
];

// Observation Section dropdown.
// Maps to the `section` field in the Observation POST payload.
export const OBSERVATION_SECTION_OPTIONS = [
    { id: 'After Activity', displayText: 'After Activity' },
  { id: 'Before Activity', displayText: 'Before Activity' },
  // { id: 'Behaviours', displayText: 'Behaviours' },
  { id: 'During Activity - Ergo', displayText: 'During Activity - Ergo' },
  { id: 'During Activity - PIT', displayText: 'During Activity - PIT' },
  { id: 'During Activity - Process', displayText: 'During Activity - Process' },
  { id: 'Reference Questions', displayText: ' Reference Questions' },
];

// ─── Racking Inspection-specific dropdown options ─────────────────────────────

// Racking Inspection Section dropdown.
// Maps to the `section` field in the Racking Inspection POST/PUT payload.
// IDs are short codes (RS, LC, DM) sent to the backend.
// displayText shows the full label in the UI.
export const RACKING_SECTION_OPTIONS = [
  { id: 'RS', displayText: 'Regulatory Standards' },
  { id: 'LC', displayText: 'Load Capacity Standard' },
  { id: 'DM', displayText: 'Damage Checklist' },
];

// ─── Site Evaluation-specific dropdown options ──────────────────────────────

// Site Evaluation is header-level only.
// Maps to the `sectionValue` field in POST/PUT payloads.
export const SITE_EVALUATION_SECTION_OPTIONS = [
  { id: 'Pre Work', displayText: 'Pre Work' },
  { id: 'VP Equipment/MHE/Supplies/Pre-Shift', displayText: 'VP Equipment/MHE/Supplies/Pre-Shift' },
  { id: 'Yard/Gate', displayText: 'Yard/Gate' },
  { id: 'Layer/Red Zone/Docks', displayText: 'Layer/Red Zone/Docks' },
  { id: 'Pick Area', displayText: 'Pick Area' },
  { id: 'Deep Reserve/Chilled/Repack', displayText: 'Deep Reserve/Chilled/Repack' },
  { id: 'Regulatory/Documentation', displayText: 'Regulatory/Documentation' },
  { id: 'Lighthouse', displayText: 'Lighthouse' },
];

// ─── NHO-specific dropdown options ────────────────────────────────────────────

// NHO Touch Type — multi-select.
// IDs must match the API string values used in `touchTypes[]`.
// Selecting Probation_30, Probation_60, Probation_90, or Preferred_Method also
// sets the corresponding numeric flag to 1 in the payload (probation30, etc.).
export const NHO_TOUCH_TYPE_OPTIONS = [
  { id: 'Probation_30', displayText: 'Milestone 1' },
  { id: 'Probation_60', displayText: 'Milestone 2' },
  { id: 'Probation_90', displayText: 'Milestone 3' },
  { id: 'Preferred_Method', displayText: 'Preferred Method' },
];

// NHO Section dropdown — drives dynamic UI behaviour in NhoAddOverlay.
// Maps to the `section` field in the NHO POST/PUT payload.
export const NHO_SECTION_OPTIONS = [
  { id: 'Data', displayText: 'Data' },
];
